/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { GenerationJobResponse } from 'src/openapi';
import { QuizState } from '../types/quiz';

const initialState: QuizState = {
  generationError: null,
};

/**
 * Live state of a generation run, and nothing else.
 *
 * The paper itself lives in the RTK Query cache (`services/quiz`) and is
 * patched in place as questions stream in. What is left here is the run's
 * stage and counters — socket-only progress that no endpoint owns.
 */
const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    resetQuizGeneration: () => initialState,

    generationFailed: (
      state,
      action: PayloadAction<
        GenerationJobResponse & { failure_reason?: string }
      >,
    ) => {
      state.generationError =
        action.payload.failure_reason ?? 'generation_failed';
    },
  },
});

export const { resetQuizGeneration, generationFailed } = quizSlice.actions;

export default quizSlice.reducer;
